export default __webpack_public_path__ + "static/media/p5.0e43af7d.png";